/**
 * Simple Error Codes Configuration
 */

export const ERROR_TYPES = {
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  INFO: 'info'
};

export const ERROR_CODES = {
  NETWORK_ERROR: 'NETWORK_ERROR',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  SERVER_ERROR: 'SERVER_ERROR',
  NOT_FOUND: 'NOT_FOUND',
  TIMEOUT: 'TIMEOUT',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR'
};

export const ERROR_CONFIG = {
  [ERROR_CODES.NETWORK_ERROR]: {
    type: ERROR_TYPES.ERROR,
    message: 'Network connection failed. Please check your internet connection.',
    color: 'error',
    autoHide: true,
    duration: 3000
  },
  [ERROR_CODES.UNAUTHORIZED]: {
    type: ERROR_TYPES.ERROR,
    message: 'You are not authorized. Please log in again.',
    color: 'error',
    autoHide: false
  },
  [ERROR_CODES.FORBIDDEN]: {
    type: ERROR_TYPES.ERROR,
    message: 'Access denied. You do not have permission.',
    color: 'error',
    autoHide: true,
    duration: 3000
  },
  [ERROR_CODES.VALIDATION_ERROR]: {
    type: ERROR_TYPES.WARNING,
    message: 'Please check your input and try again.',
    color: 'warning',
    autoHide: true,
    duration: 3000
  },
  [ERROR_CODES.SERVER_ERROR]: {
    type: ERROR_TYPES.ERROR,
    message: 'Server error. Please try again later.',
    color: 'error',
    autoHide: true,
    duration: 3000
  },
  [ERROR_CODES.NOT_FOUND]: {
    type: ERROR_TYPES.WARNING,
    message: 'The requested resource was not found.',
    color: 'warning',
    autoHide: true,
    duration: 3000
  },
  [ERROR_CODES.TIMEOUT]: {
    type: ERROR_TYPES.WARNING,
    message: 'Request timed out. Please try again.',
    color: 'warning',
    autoHide: true,
    duration: 3000
  },
  [ERROR_CODES.UNKNOWN_ERROR]: {
    type: ERROR_TYPES.ERROR,
    message: 'An unexpected error occurred. Please try again.',
    color: 'error',
    autoHide: true,
    duration: 3000
  }
};

/**
 * Maps HTTP status codes to error codes
 */
export const HTTP_STATUS_MAPPING = {
  400: ERROR_CODES.VALIDATION_ERROR,
  401: ERROR_CODES.UNAUTHORIZED,
  403: ERROR_CODES.FORBIDDEN,
  404: ERROR_CODES.NOT_FOUND,
  408: ERROR_CODES.TIMEOUT,
  500: ERROR_CODES.SERVER_ERROR,
  502: ERROR_CODES.SERVER_ERROR,
  503: ERROR_CODES.SERVER_ERROR,
  504: ERROR_CODES.TIMEOUT
};

/**
 * Maps network error types to error codes
 */
export const NETWORK_ERROR_MAPPING = {
  'Network Error': ERROR_CODES.NETWORK_ERROR,
  'timeout': ERROR_CODES.TIMEOUT,
  'ECONNABORTED': ERROR_CODES.TIMEOUT,
  'ENOTFOUND': ERROR_CODES.NETWORK_ERROR,
  'ECONNREFUSED': ERROR_CODES.SERVER_ERROR
};
